module.exports = __webpack_public_path__ + "media/images/s02_01_en-83f0f4c209fbf5ab724cc1a5d4d51f17.svg";